/* Publish by EComposer at 2024-06-13 22:46:42*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gutocofh18r"]=  window.__ectimmers["ecom-gutocofh18r"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-gutocofh18r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gutocofh18r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uu31jt9gfp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uu31jt9gfp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0lb6q38crsmn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0lb6q38crsmn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wjmi0re5b7e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wjmi0re5b7e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0xkpigpz136').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0xkpigpz136', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gcstnjhzsk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gcstnjhzsk9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fzylx5o2g7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fzylx5o2g7h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2vcykf21qbp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2vcykf21qbp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-35qymcgv9bm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-35qymcgv9bm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-izhkk24rnp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-izhkk24rnp', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gg2oh71z2l"]=  window.__ectimmers["ecom-gg2oh71z2l"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-gg2oh71z2l"]["61ds6ems1"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click(),Shopify.analytics.publish("ec_custom_events",{button_id:i.id,tracking_id:i.dataset.ecTrackingId}),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-gg2oh71z2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gg2oh71z2l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yn6kvrh92o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yn6kvrh92o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wirxkx99cp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wirxkx99cp', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-53g39kwp998"]=  window.__ectimmers["ecom-53g39kwp998"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-53g39kwp998').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53g39kwp998', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vzkqddkkfs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vzkqddkkfs', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-by4q7nfwmpq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-by4q7nfwmpq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xlman3y2ku').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xlman3y2ku', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n707kbjr53').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n707kbjr53', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1am077eiijw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1am077eiijw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-05jh3eulltn4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-05jh3eulltn4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6cm2hamucl"]=  window.__ectimmers["ecom-6cm2hamucl"] || {};
if(!this.settings||!this.$el)return;var e=this.$el.querySelector(".ecom-video_overlay-icon");e&&e.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"){let n=this.$el.querySelector(".ecom_video");n.autoplay=!0,n.load(),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}else{let n=this.$el.querySelector(".ecom_iframe"),s=n.getAttribute("src");s.includes("autoplay=0")?s=s.replace("autoplay=0","autoplay=1"):s=s+"&autoplay=1",n.setAttribute("src",s),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}}),this.$el.querySelectorAll("[data-ec-tracking-id]").forEach(function(n){n.dataset.ecTrackingId&&n.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:n.id,tracking_id:n.dataset.ecTrackingId})},{once:!0})});const i=this.$el.querySelector("[ecom-modal]");if(i&&this.settings.image_overlay&&this.settings.play_on_lightbox&&window.EComModal){var t=this.id;new window.EComModal(i,{cssClass:[t,"ecom-core","ecom-core-simulator"],onOpen:function(){var n=document.querySelector(".ecom-modal."+t);n&&n.querySelector(".ecom-modal-box__content").classList.add("ecom-element_video-iframe")}})}

                    });
                    
                        document.querySelectorAll('.ecom-6cm2hamucl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6cm2hamucl', settings: {"source":"hosted","image_overlay":true},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}